export enum IstatStatus {
  IstatStatusCheckInSentError = 'ISTAT_STATUS_CHECK_IN_SENT_ERROR',
  IstatStatusCheckInSentOk = 'ISTAT_STATUS_CHECK_IN_SENT_OK',
  IstatStatusCheckOutSentError = 'ISTAT_STATUS_CHECK_OUT_SENT_ERROR',
  IstatStatusCheckOutSentOk = 'ISTAT_STATUS_CHECK_OUT_SENT_OK',
  IstatStatusStillSentError = 'ISTAT_STATUS_STILL_SENT_ERROR',
  IstatStatusStillSentOk = 'ISTAT_STATUS_STILL_SENT_OK',
}
